<div class="card-random-wrap-v3">
    <div class="content" (click)="openPopup()">
        <div class="top-img">
            <svg xmlns="http://www.w3.org/2000/svg" width="232" height="210" viewBox="0 0 232 210" fill="none">
                <path opacity="0.9" fill-rule="evenodd" clip-rule="evenodd"
                    d="M304.959 5.40583C319.391 38.5857 325.466 75.8173 309.189 112.383C292.648 149.542 259.817 182.555 218.64 199.316C179.677 215.176 137.731 210.122 102.555 196.493C71.5652 184.485 57.5715 156.888 41.5499 130.699C23.0493 100.458 -10.4092 71.6639 4.12203 35.5944C18.8557 -0.977488 68.736 -14.7429 107.791 -33.7257C147.5 -53.0263 188.267 -81.3667 228.379 -73.4058C269.555 -65.2336 290.019 -28.9431 304.959 5.40583Z"
                    fill="url(#paint0_linear_8258_8793)" fill-opacity="0.3" />
                <defs>
                    <linearGradient id="paint0_linear_8258_8793" x1="270.684" y1="26.42" x2="16.7306" y2="118.621"
                        gradientUnits="userSpaceOnUse">
                        <stop stop-color="#01BFBD" />
                        <stop offset="1" stop-color="#01BFBD" stop-opacity="0" />
                    </linearGradient>
                </defs>
            </svg>
        </div>
        <div class="bottom-img">
            <svg xmlns="http://www.w3.org/2000/svg" width="135" height="178" viewBox="0 0 135 178" fill="none">
                <path opacity="0.7" fill-rule="evenodd" clip-rule="evenodd"
                    d="M-20.9153 250.287C-50.9804 241.134 -79.0162 224.174 -94.0184 192.813C-109.264 160.943 -112.592 120.641 -100.474 83.9764C-89.0069 49.2838 -62.0341 24.4012 -33.2064 8.82609C-7.80901 -4.89572 18.3187 1.40124 44.6579 5.5642C75.0725 10.3713 112.958 4.47498 128.616 34.4024C144.492 64.7466 125.49 105.477 116.036 141.99C106.423 179.114 102.191 222.031 74.3295 244.063C45.7289 266.679 10.2092 259.762 -20.9153 250.287Z"
                    fill="url(#paint0_linear_8258_8794)" fill-opacity="0.4" />
                <defs>
                    <linearGradient id="paint0_linear_8258_8794" x1="-15.4974" y1="215.789" x2="66.6253" y2="-4.03863"
                        gradientUnits="userSpaceOnUse">
                        <stop stop-color="#01BFBD" />
                        <stop offset="1" stop-color="#01BFBD" stop-opacity="0" />
                    </linearGradient>
                </defs>
            </svg>
        </div>
        <div class="details">
            <div class="top">
                <img class="card-icon" src="/assets/images/browse-campaign/random-fundraiser-card-banner.png">
            </div>
            <div class="bottom">
                <span class="title">Not sure who to help?Let us decide</span>
                <span class="desc">
                    We'll randomly select a campaign that needs your support urgently.
                </span>
            </div>
        </div>
        <div class="random-select-btn">
            <button mat-button>Auto-Select a Fundraiser</button>
        </div>
    </div>
</div>

<ng-template *ngIf="showBlurModal" [ngTemplateOutlet]="randomFundariserAnimation" />
<ng-template #randomFundariserAnimation>
    <div class="textMessage">
        <img class="animationGif" [src]="isMobile ? '/assets/images/browse-campaign/randomLoaderMweb.gif' : '/assets/images/browse-campaign/randomLoaderWeb.gif'" alt="random fundraiser picker">
        <img class="details" [src]="isMobile ? '/assets/images/browse-campaign/background-random-fundraiser-mweb.png' : '/assets/images/browse-campaign/background-random-fundraiser.png'" alt="picking random fundraiser text">
        <div class="loadingText">
            <span class="title">
                Spinning the wheel of kindness...
            </span>
            <span class="desc">
                Hang tight! We're picking an urgent campaign at random.
            </span>
        </div>
    </div>
</ng-template>